import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { FaAlignRight, FaHome, FaUser, FaLayerGroup, FaProjectDiagram } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { useState } from "react";
import "./CSS/NavTop.css";

function NavTop() {
  const [toogleMenu, setToogleMenu] = useState(false);

  function toogleOpen() {
    setToogleMenu(true);
  }

  function toogleClose() {
    setToogleMenu(false);
  }

  if (toogleMenu) {
    return (
      <>
        <NavTop />
        <div className="menu">
          <Container fluid className="menu-close">
            <button className="toogle-menu ms-auto" onClick={toogleClose} aria-label="Close navigation menu">
              <GrClose />
            </button>
            <div className="menu-list">
              <NavLink to="/" onClick={toogleClose}>
                <FaHome /> Home
              </NavLink>
              <NavLink to="/about" onClick={toogleClose}>
                <FaUser /> About
              </NavLink>
              <NavLink to="/services" onClick={toogleClose}>
                <FaLayerGroup /> Services
              </NavLink>
              <NavLink to="/projects" onClick={toogleClose}>
                <FaProjectDiagram /> Projects
              </NavLink>
            </div>
          </Container>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar className="navtop py-3" expand="lg">
        <Container fluid className="px-4">
          <Navbar.Brand className="navtop-brand">
            <Link to="/">
              Lee
            </Link>
          </Navbar.Brand>
          <button className="toogle-menu" onClick={toogleOpen} aria-label="Open navigation menu">
            <FaAlignRight />
          </button>
          <Nav className="navtop-list ms-auto">
            <Nav.Link className="pe-3">
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaHome /> Home
              </NavLink>
            </Nav.Link>
            <Nav.Link className="pe-3">
              <NavLink
                to="/about"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaUser /> About
              </NavLink>
            </Nav.Link>
            <Nav.Link className="pe-3">
              <NavLink
                to="/services"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaLayerGroup /> Services
              </NavLink>
            </Nav.Link>
            <Nav.Link className="pe-3">
              <NavLink
                to="/projects"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaProjectDiagram /> Projects
              </NavLink>
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}

export default NavTop;
